import { NgModule } from '@angular/core';
import { AdpmServicesComponent } from './adpm-services.component';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { UploadService } from './upload.service';
import { ApiPublicRequestService } from './api-public-request.service';
import { ApiRequestService } from './api-request.service';
import { DownloadService } from './download.service';
import { FileService } from './file.service';
import { LoginService } from './login.service';
import { LogoutService } from './logout.service';
import { OrgInfoService } from './org-info.service';
import { OrganizacaoService } from './organizacao.service';
import { TituloService } from './titulo.service';
import { UsuarioInfoService } from './usuario-info.service';
import { UtilService } from './util.service';



@NgModule({
  declarations: [AdpmServicesComponent],
  imports: [
    HttpClientModule
  ],
  exports: [AdpmServicesComponent],
  providers: [
    ApiPublicRequestService,
    ApiRequestService,
    DownloadService,
    FileService,
    LoginService,
    LogoutService,
    OrgInfoService,
    OrganizacaoService,
    TituloService,
    UploadService,
    UsuarioInfoService,
    UtilService,
    HttpClient,
    TituloService
  ]
})
export class AdpmServicesModule { }
